import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-266dbbfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "record" }
const _hoisted_2 = { class: "statitiscal" }
const _hoisted_3 = { class: "pv" }
const _hoisted_4 = { class: "uv" }
const _hoisted_5 = { class: "ip" }
const _hoisted_6 = { style: {"height":"60px","display":"inline-flex","margin":"0 auto"} }
const _hoisted_7 = { style: {"height":"60px","line-height":"60px","text-align":"center","margin-left":"14px"} }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon-collection-tag" }, null, -1))
const _hoisted_10 = { class: "modal" }
const _hoisted_11 = { class: "modalHeader" }
const _hoisted_12 = { key: 0 }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { accessTableConfig } from './config/access.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { ref, watch } from 'vue'
import { toDay, secondToMin } from '@/utils/date-format'
import { getPageListData } from '@/service/main/system'
import { useRoute } from 'vue-router'
import LfTable from '@/components/LfTable.vue'
import { useStore } from '@/store'
import { initEmptyParam } from '@/hooks/useInitParam'
import localCache from '@/utils/cache'
import { queryStatistical } from '@/service/main/consumer/statitiscal'


export default /*#__PURE__*/_defineComponent({
  __name: 'Record',
  setup(__props) {

initEmptyParam()
const pageInfo = ref({ pageNo: 1, pageSize: 10 })
const store = useStore()
const userInfo = store.state.login.userInfo

const dialogVisible = ref(false)

const route = useRoute()
let query = {}
if (route.query['deptId']) {
  const depts = store.state.login.depts
  for (const dept of depts) {
    if (dept.id == route.query['deptId']) {
      const empIds = []
      for (const emp of dept.emps) {
        empIds.push(emp.id)
      }
      query = { empIds }
    }
  }
  query = { ...query, updatedTime: route.query.updatedTime }
} else {
  query = { ...route.query }
}

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return { title: item.realName, value: item.id }
  })
  const userItem = searchFormConfig.formItems.find(
    (item) => item.field === 'empIds'
  )
  userItem!.options = userOptions
}
getEmp()

let today = new Date()
let day = today.getDay() || 7 // 将周日转化为7
let monday = new Date(today)
monday.setDate(today.getDate() - day + 1)

const queryParam = {
  empIds: userInfo.id,
  // empTag: parseInt(userInfo.empTag),
  updatedTime: [monday.toISOString().slice(0, 10), toDay()],
  ...query
}
store.commit('system/changeQueyryInfo', queryParam)

let queryInfo = {}

const entity = ref<any>({ nickName: '', belongDeptName: '', belongEmpName: '' })

const handleAccessClick = (item: any) => {
  entity.value = item
  dialogVisible.value = true
  getPageData(item.id)
}
//获取数据
const dataList = ref<any[]>([])
const dataCount = ref<number>(0)

const getPageData = async (id: string) => {
  queryInfo = {
    consumerId: id,
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize
  }

  const data = await getPageListData('/main/consumer/consumerAccess', queryInfo)
  dataList.value = data.list
  dataCount.value = Number(data.total)
}

//监听分页事件
watch(pageInfo, () => getPageData(queryInfo.consumerId))

const statitiscal = ref({ weeknum: 0, avgnum: 0, over30num: 0 })

const searchCb = async (item: any) => {
  statitiscal.value = await queryStatistical(item)
}

searchCb({ ...queryParam, pageNo: 1, pageSize: 1000 })

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const resetCb = () => {
  return queryParam
}

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(
  resetCb,
  searchCb
)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode("本周听课总人数: "),
        _createElementVNode("em", null, _toDisplayString(statitiscal.value.weeknum), 1)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createTextVNode("日均听课人数: "),
        _createElementVNode("em", null, _toDisplayString(Math.floor(statitiscal.value.avgnum / _unref(day))), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createTextVNode("本周听课超过30分钟人数: "),
        _createElementVNode("em", null, _toDisplayString(statitiscal.value.over30num), 1)
      ])
    ]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "consumerRecord",
      onSortChange: handleSortChange
    }, {
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToMin)(scope.row.duration)), 1)
      ]),
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 60,
            src: scope.row.headImgUrl
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(scope.row.nickName), 1)
        ])
      ]),
      call: _withCtx((scope) => [
        _createVNode(_component_el_link, {
          type: scope.row.callNum >= 3 ? 'danger' : 'primary',
          href: "javascript:;",
          underline: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.callNum), 1)
          ]),
          _: 2
        }, 1032, ["type"])
      ]),
      lecture: _withCtx((scope) => [
        _createElementVNode("div", {
          onClick: ($event: any) => (handleAccessClick(scope.row))
        }, [
          _createVNode(_component_el_link, {
            type: scope.row.lectureNum >= 3 ? 'danger' : 'primary',
            href: "javascript:;",
            underline: false
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createTextVNode(_toDisplayString(scope.row.lectureNum), 1)
            ]),
            _: 2
          }, 1032, ["type"])
        ], 8, _hoisted_8)
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_dialog, {
        title: "历史访问记录",
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
        width: "50%",
        center: "",
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", null, "客户昵称: " + _toDisplayString(entity.value.nickName), 1),
            _createElementVNode("span", null, "所属部门: " + _toDisplayString(entity.value.belongDeptName), 1),
            _createElementVNode("span", null, "所属员工: " + _toDisplayString(entity.value.belongEmpName), 1)
          ]),
          _createVNode(LfTable, _mergeProps({
            listData: dataList.value,
            listCount: dataCount.value
          }, _unref(accessTableConfig), {
            page: pageInfo.value,
            "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((pageInfo).value = $event))
          }), {
            duration: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(_unref(secondToMin)(scope.row.duration)), 1)
            ]),
            content: _withCtx((scope) => [
              (!scope.row.url)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(scope.row.content), 1))
                : (_openBlock(), _createBlock(_component_el_link, {
                    key: 1,
                    href: scope.row.url,
                    type: "primary",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.content), 1)
                    ]),
                    _: 2
                  }, 1032, ["href"]))
            ]),
            _: 1
          }, 16, ["listData", "listCount", "page"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})